import { Injectable, Injector } from '@angular/core';
import { SERVER_URL } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  queryToken: any;
  encQueryParam: any;
  queryParams: any;
  player_initial_data: any;
  playerFullData: any;
  isLogged: boolean = false;
  USER_TOKEN: any;
  additional_info: any;
  couponCode: any;

  onChangeQueryParams = new Subject<any>();

  constructor(
    public http: HttpClient,
    private storage: Storage, private route: ActivatedRoute, public injector: Injector
  ) {
    console.debug("AuthService constructor", window.location.search);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('tk');
    const enc = urlParams.get('query_params');
    console.log("AuthService token", token, enc);
    if (token) this.queryToken = token;
    if (enc) this.encQueryParam = enc;
  }


  /** 
    * Signup an User
    * 
    * @author Santiago Cardenas (snt-1017)
    * @param {Object} questions - Signup form info
    * @param {Object} counter - Value used to return specific error information from backend
    * @param {Object} validation_code - Validation code when the value comes by queryparams
    * @returns {Promise<String>} - It will return error 400 if the user already exists
    * 
  **/
  signup(questions, counter, validation_code, login_type, additional_info = null, referralCode?: string | null): Promise<any> {
    const url = SERVER_URL + '/crm/signup/'
    console.log("si existe el referral lo mestra aquí", referralCode)
    const body = {
      email: questions[0].formControl.value,
      username: questions[0].formControl.value,
      first_name: questions[1].formControl.value,
      last_name: questions[2].formControl.value,
      cellphone: questions[3].formControl.value,
      document_type: questions[4].formControl.value,
      document: questions[5].formControl.value,
      terms_and_conditions: true,
      referral_code: referralCode,
      additional_info: {}
    }
    if (login_type == "Password") {
      body['password'] = questions[6].formControl.value
    }
    // Add dynamic information.
    for (let i = 6; i < questions.length; i++) {
      const element = questions[i];
      if (element.id == 'servientrega_city') {
        let city = element.formControl.value;
        body['servientrega_city'] = city.value;
      } else if (element.id == "internal_id") {
        body['internal_id'] = element.formControl.value
      } else if (element.id == "validation_code") {
        body['validation_code'] = element.formControl.value;
      } else if (element.id == "additional_info") {
        body.additional_info[element.label] = element.formControl.value;
      }
    }
    body['counter'] = counter
    if (validation_code) body['validation_code'] = validation_code
    if (additional_info) body['additional_info'] = additional_info
    // console.debug(body);
    return this.http.post(url, body).toPromise()
  }


  /** 
   * Login an User
   * 
   * @author Brayan Garcia (bsgarciac)
   * @param {Object} questions - Login form info, it is important the order of the fields
   * @returns {Promise<String>} - It will return error 400 if the password or the email is incorrect
   * 
 **/
  login(questions): Promise<any> {
    const url = SERVER_URL + '/rest-auth/login/';
    const body = {
      email: questions[0].formControl.value,
      password: questions.find((question) => question.label === 'Contraseña').formControl.value
    }
    return this.http.post(url, body).toPromise().then((token: any) => {
      this.setToken(token.key)
    })
  }

  methodCodeOtp(questions, method): Promise<any> {
    const url = SERVER_URL + '/crm/method-code/';
    let body;
    if (method == "Email") {
      body = {
        email: questions[0].formControl.value
      }
    } else {
      body = {
        document: questions[0].formControl.value
      }
    }
    return this.http.post(url, body).toPromise().then((method: any) => {
      console.log("method", method);
      return method
    })
  }

  sendCodeOtp(questions, method): Promise<any> {
    const url = SERVER_URL + '/crm/send-code/';
    const body = {
      method: method,
      email: questions[0].formControl.value,
    }
    return this.http.post(url, body).toPromise().then((method: any) => {
      console.log("method", method);
      return method
    });
  }

  verificationCodeOtp(questions, code): Promise<any> {
    const url = SERVER_URL + '/crm/verify-code/';
    const body = {
      code: code,
      email: questions[0].formControl.value
    }
    return this.http.post(url, body).toPromise().then((token: any) => {
      console.log("token", token);
      this.setToken(token[1].token)
    });
  }

  login_with_document(questions): Promise<any> {
    const url = SERVER_URL + '/rest-auth/login/';
    const body = {
      document: questions[0].formControl.value,
      password: questions[1].formControl.value
    }
    return this.http.post(url, body).toPromise()
      .then((token: any) => {
        this.setToken(token.key)
      })
  }


  setToken(token) {
    this.isLogged = true;
    this.USER_TOKEN = token;
    this.storage.set('token', this.USER_TOKEN);
    if (!this.player_initial_data) this.getPlayerInitialData();
  }

  /** 
    * Returns true if token exists
    * 
    * @author Brayan Garcia (bsgarciac)
    * @returns {Boolean} - This functions returns True if token exists 
    * 
  **/
  async checkAutentication(): Promise<any> {
    if (this.queryToken) {
      let is_valid = await this.verifyToken(this.queryToken);
      if (!is_valid) {
        this.isLogged = false;
        this.USER_TOKEN = null;
        this.storage.remove('token');
        return Promise.resolve(false);
      }
      this.setToken(this.queryToken);
      return Promise.resolve(true)
    } else if (this.encQueryParam) {
      let data = await this.getEncryptedToken(this.encQueryParam);
      console.debug("Encrypted data", data);
      let token = data.token;
      let is_valid = await this.verifyToken(token);
      if (!is_valid) {
        this.isLogged = false;
        this.USER_TOKEN = null;
        this.storage.remove('token');
        return Promise.resolve(false);
      }
      this.setToken(token);
      this.queryParams = data.query_params;
      this.onChangeQueryParams.next(data.query_params);
      return Promise.resolve(true);
    } else {
      let val = await this.storage.get('token');
      // If token not stored in local storage return false
      if (!val) return Promise.resolve(false);
      let is_valid = await this.verifyToken(val);
      if (!is_valid) {
        this.isLogged = false;
        this.USER_TOKEN = null;
        this.storage.remove('token');
        return Promise.resolve(false);
      }
      this.setToken(val);
      return Promise.resolve(true);
    }
  }

  /** 
    * Returns the authentication requestionOptions needed by HttpClient
    * 
    * @author Brayan Garcia (bsgarciac)
    * @returns {Object} - This functions returns the final RequestOptionObject composed only by the Header 
    * 
  **/
  getAuthHeaders() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'token ' + this.USER_TOKEN
      })
    }
    return httpOptions
  }

  getSimpleAuthHeaders() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'token ' + this.USER_TOKEN
    })
    return headers
  }

  /** 
    * Function to logout the user and remove its token
    * 
    * @author Brayan Garcia (bsgarciac)
    * 
  **/
  logout() {
    this.player_initial_data = null;
    this.queryToken = null;
    this.encQueryParam = null;
    this.isLogged = false;
    this.storage.remove('token');
    const url = SERVER_URL + '/rest-auth/logout/'
    const httpOptions = this.getAuthHeaders()
    this.http.post(url, {}, httpOptions)
  }

  /** 
    * Function to get user first name, last name and player points
    * 
    * @author Brayan Garcia (bsgarciac)
    * @returns {Object} - It returns one object with the player initial information(showed in menu)
    * 
  **/
  getPlayerInitialData(): Promise<any> {
    //If user exist and location is not complete order
    console.debug("getPlayerInitialData", this.player_initial_data, window.location.href);
    if (this.player_initial_data && !window.location.href.includes('complete-order')) return this.player_initial_data
    // If user not exist or location is complete order
    const url = SERVER_URL + '/crm/get_player_initial_data/'
    const headers = this.getAuthHeaders();
    return this.http.get(url, headers).toPromise().then((data) => {
      this.player_initial_data = data;
      return this.player_initial_data;
    }).catch((err) => {
      console.debug("Error getting player initial data", err);
      return null;
    });
  }

  /** 
    * Function to get the entire user data
    * 
    * @author Brayan Garcia (bsgarciac)
    * @returns {Object} - It returns one object with the player information
    * 
  **/
  getPlayerFullData(refresh = true): Promise<any> {
    if (!refresh && this.playerFullData) return this.playerFullData;
    const url = SERVER_URL + '/crm/get_player_full_data/'
    const headers = this.getAuthHeaders();
    return this.http.get(url, headers).toPromise().then((data) => {
      this.playerFullData = data;
      return this.playerFullData;
    }).catch((err) => { return null; });
  }


  /** 
    * Function to update user data
    * 
    * @author Brayan Garcia (bsgarciac)
    * 
  **/
  editUserData(profileForm): Promise<any> {
    const url = SERVER_URL + '/crm/edit_user_data/'
    const headers = this.getAuthHeaders();
    const body = {
      first_name: profileForm.controls.name.value,
      last_name: profileForm.controls.lastname.value,
      document: profileForm.controls.document.value,
      document_type: profileForm.controls.document_type.value,
      cellphone: profileForm.controls.cellphone.value,
      gender: profileForm.controls.gender.value,
      born_date: profileForm.controls.born_date.value,
      address: profileForm.controls.address.value,
    }
    var city = profileForm.controls.city.value
    body['servientrega_city'] = city.value
    return this.http.patch(url, body, headers).toPromise()
  }


  /** 
    * Function to update user data
    * 
    * @author Santiago Cardenas (snt-1017)
    * 
  **/
  updateAutoRedemptionWalletData(newState: boolean): Promise<any> {
    const url = SERVER_URL + '/crm/auto-redemption-wallet/'
    const headers = this.getAuthHeaders();
    const body = {
      automatic_redemption_wallet: newState
    }
    return this.http.patch(url, body, headers).toPromise().then((data) => {
      this.player_initial_data.automatic_redemption_wallet = newState;
      this.playerFullData.automatic_redemption_wallet = newState;
      return data;
    })
  }

  updatePlayerData(questions)/* :Promise<any> */ {

    const url = SERVER_URL + '/crm/update_player_data/'
    const headers = this.getAuthHeaders();
    const body = {}
    for (let question of questions) {
      body[question.name] = question.formControl.value
    }
    return this.http.patch(url, body, headers).toPromise()
  }

  updateNumberLogin(number_of_logins): Promise<any> {
    const url = SERVER_URL + '/crm/update_number_of_login/'
    const headers = this.getAuthHeaders();
    const body = {
      number_of_logins: number_of_logins + 1,
    }
    return this.http.patch(url, body, headers).toPromise()
  }

  cancelAskInformation(): Promise<any> {
    const url = SERVER_URL + '/crm/update_ask_information/'
    let headers = this.getAuthHeaders();
    let body = {
      ask_info: false
    };
    return this.http.patch(url, body, headers).toPromise()
  }

  updateAdditionalPlayerData(questions) {
    let additional_info = {}
    for (let question of questions) {
      additional_info[question.label] = question.formControl.value
    }
    const url = SERVER_URL + '/crm/update_addicional_info/'
    const headers = this.getAuthHeaders();
    const body = {
      additional_info
    }
    return this.http.patch(url, body, headers).toPromise()

  }

  /** 
    * Function to send reset password email
    * 
    * @author Brayan Garcia (bsgarciac)
    * @param {String} email - email where is going to be sent the message
    *  
  **/
  sendRestorePasswordEmail(email): Promise<any> {
    const url = SERVER_URL + '/rest-auth/password/reset/'
    const body = { email }
    return this.http.post(url, body).toPromise();
  }


  /** 
    * Reset the password of an account
    * 
    * @author Brayan Garcia (bsgarciac)
    * @param {String} uid - ID of the user
    * @param {String} token - Token of the user
    * @param {Array<Object>} questions - Questions of the form
    * @returns {Promise<String>}
    * 
  **/
  restorePassword(uid, token, questions) {
    let url = SERVER_URL + '/rest-auth/password/reset/confirm/';
    let body = {
      uid: uid,
      token: token,
      new_password1: questions[0].formControl.value,
      new_password2: questions[1].formControl.value
    };
    return this.http.post(url, body).toPromise()
  }


  /** 
    * Custom Login For PMI
    * 
    * @author Brayan Garcia (bsgarciac)
    * @param {String} encrypted - Encrypted text in AES that has all the user information
    * @returns {Promise<String>}
    * 
  **/
  pmiLogin(encrypted) {
    let url = SERVER_URL + '/pmi/login/';
    let body = {
      encrypted: encrypted.replace(/\s/g, '+')
    };
    return this.http.post(url, body).toPromise().then((info: any) => {
      this.isLogged = true;
      this.USER_TOKEN = info.key
      this.storage.set('token', this.USER_TOKEN)
      const extraInfo = { ...(info.additional_info || {}), ...(info.additional_params || {}) };
      console.log("ADDITONAL_INFO", extraInfo)
      this.additional_info = extraInfo;
    })
  }


  customOauth(encrypted){
    let url = SERVER_URL + '/crm/oauth/login/';
    let body = {
      tk: encrypted.replace(/\s/g, '+')
    };
    return this.http.post(url, body).toPromise().then((info: any) => {
      this.isLogged = true;
      this.USER_TOKEN = info.key
      this.storage.set('token', this.USER_TOKEN)
      const extraInfo = { ...(info.additional_info || {}), ...(info.additional_params || {}) };
      console.log("ADDITONAL_INFO", extraInfo)
      this.additional_info = extraInfo;
    })
  }

  getValidationCode(cellphone): Promise<any> {
    const url = SERVER_URL + '/crm/get_validation_code/';
    const params = {
      cellphone
    };
    return this.http.get(url, { params }).toPromise();
  }

  getInformationByToken(token): Promise<any> {
    const url = SERVER_URL + '/crm/get-information-by-token/';
    const params = {
      token
    };
    return this.http.get(url, { params }).toPromise();
  }

  async getNews(newId?: number) {
    const url = SERVER_URL + '/crm/news/' + (newId ? newId + '/' : '');
    const headers = this.getSimpleAuthHeaders()
    let params: any;
    await this.getPlayerFullData().then((data) => {
      console.log(data.company)
      params = { 'company_id': data.company }
    })
    return this.http.get(url, { params, headers }).toPromise()
  }

  /** 
    * Validate preregistered identity
    * 
    * @author Santiago Cardenas (snt-1017)
    * @param {Object} questions - Signup form info
    * @returns {Promise<String>} - It will return error error if the data is not valid
    * 
  **/
  validateIdentity(questions): Promise<any> {
    const url = SERVER_URL + '/crm/validate-identity/'
    const body = {
      email: questions[0].formControl.value,
      password: questions[1].formControl.value,
      username: questions[0].formControl.value,
      first_name: questions[2].formControl.value,
      last_name: questions[3].formControl.value,
      cellphone: questions[4].formControl.value,
      document: questions[5].formControl.value,
      additional_info: {}
    }
    // Add dynamic information.
    for (let i = 6; i < questions.length; i++) {
      const element = questions[i];
      if (element.id == 'servientrega_city') {
        let city = element.formControl.value;
        body['servientrega_city'] = city.value;
      } else if (element.id == "internal_id") {
        body['internal_id'] = element.formControl.value
      } else if (element.id == "additional_info") {
        body.additional_info[element.label] = element.formControl.value;
      }
    }
    // console.debug(body);
    return this.http.post(url, body).toPromise()
  }

  /** 
    * Function to send accept terms and conditions
    * 
    * @author Santiago Osorio 
    * @param {player_id} playerId - player id what accept the terms and conditions
    *  
  **/
  sendAcceptTermsAndConditions(body): Promise<any> {
    const url = SERVER_URL + '/crm/accept_terms_and_conditions/'
    const httpOptions = this.getAuthHeaders()
    console.log('body', body)
    return this.http.post(url, body, httpOptions).toPromise();
  }




  // Método para verificar si el token está activo en la base de datos
  async verifyToken(token): Promise<boolean> {
    try {
      const url = SERVER_URL + '/crm/validate_token/?token=' + token;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      })
      const response = await this.http.get(url, { headers }).toPromise();
      return response['valid'];
    } catch (error) {
      return false;
    }
  }




  // Método para verificar si el token está activo en la base de datos
  async getEncryptedToken(token): Promise<any> {
    try {
      const url = SERVER_URL + '/crm/get-information-by-query-params/?query_params=' + token;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      })
      const response: any = await this.http.get(url, { headers }).toPromise();
      return response;
    } catch (error) {
      return null;
    }
  }


  sendValidationOtpCode(document, email, phoneNumber, validationMethod) {
    const url = SERVER_URL + '/crm/signup-send-code/';
    const body = {
      document: document,
      email: email,
      cellphone: phoneNumber,
      method: validationMethod
    }
    return this.http.post(url, body).toPromise();
  }

  validateValidationOtpCode(code) {
    const url = SERVER_URL + '/crm/signup-validate-code/';
    const body = {
      code: code
    }
    return this.http.post(url, body).toPromise();
  }

  validateClientId(clientId): Promise<boolean> {
    const url = SERVER_URL + '/crm/validate-client-id/';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const body = { client_id: clientId };
    return this.http.post(url, body, { headers }).toPromise().then((data: any) => data.valid);
  }

  oauthAuthenticate(clientId, redirectUri, scope, state): Promise<any> {
    const url = SERVER_URL + '/crm/oauth-authenticate/';
    const headers = this.getAuthHeaders();
    const body = {
      client_id: clientId,
      redirect_uri: redirectUri,
      scope,
      state
    };
    return this.http.post(url, body, headers).toPromise();
  }


  getWalletUniqueToken() {
    const url = SERVER_URL + '/crm/login-wallet/';
    let httpOptions = this.getAuthHeaders();
    return this.http.get(url, httpOptions).toPromise();
  }


  getPlayerKpis(){
    const url = SERVER_URL + '/kpis/player/';
    let httpOptions = this.getAuthHeaders();
    return this.http.get(url, httpOptions).toPromise()
  }

  getPlayerKpiBySlug(slug){
    const url = SERVER_URL + '/kpis/player/' + slug + '/';
    let httpOptions = this.getAuthHeaders();
    return this.http.get(url, httpOptions).toPromise()
  }

  visitsToTheLink(referralCode) {
    const url = SERVER_URL + '/analytics/log/public/'
    const body = {
      action: "referral_landing",
      page: "/referido",
      params: {
        referral_code: referralCode
      }
    }

    return this.http.post(url, body).toPromise()
  }

}
